import type { Area } from "react-easy-crop";

const OUTPUT_SIZE = 512;

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", () => reject(new Error("无法加载图片")));
    image.src = src;
  });
}

/** 将裁剪区域导出为 512×512 JPEG blob，供头像上传。 */
export async function cropImageToAvatarBlob(imageSrc: string, pixelCrop: Area): Promise<Blob> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) throw new Error("无法创建画布");

  canvas.width = OUTPUT_SIZE;
  canvas.height = OUTPUT_SIZE;
  context.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    OUTPUT_SIZE,
    OUTPUT_SIZE,
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("导出头像失败"))),
      "image/jpeg",
      0.92,
    );
  });
}
